import { Component, OnInit, Input } from '@angular/core'
import { CampaignInfo } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'app-campaign-item',
   templateUrl: './campaign-item.component.html',
   styles: [],
   standalone: false,
})
export class CampaignItemComponent implements OnInit {
   @Input()
   public campaign: CampaignInfo

   constructor() {}

   ngOnInit(): void {}
}
